import { mapState } from 'vuex'
import { Orientations } from '@/enums/products'
import { showLoyaltyProgram } from '@/utils/general'
import { CountryCodes } from '@/enums/general'
import { WebsiteCategories } from '@/enums/app'

export default {
  computed: {
    footer () {
      return {
        faqColumn: [
          {
            display: true,
            classes: '',
            nuxtLink: this.isWomenCategory ? 'women-customer-service' : 'men-customer-service',
            text: this.$t('Navigation.FAQ'),
            showArrow: false
          },
          {
            display: true,
            classes: 'hidden md:block',
            link: `/${this.locale}-${this.country}/login`,
            text: this.$t('LoginForm.Login'),
            showArrow: false
          },
          {
            display: true,
            classes: '',
            link: this.isWomenCategory ? `/${this.locale}-${this.country}${this.$t('FooterLinks.Woman.FaqShipping')}` : `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqShipping')}`,
            text: this.$t('Footer.ShippingDelivery'),
            showArrow: true
          },
          {
            display: true,
            classes: '',
            link: this.isWomenCategory ? `/${this.locale}-${this.country}${this.$t('FooterLinks.Woman.FaqPayments')}` : `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqPayments')}`,
            text: this.$t('Footer.Payment'),
            showArrow: true
          },
          {
            display: true,
            classes: '',
            link: this.isWomenCategory ? `/${this.locale}-${this.country}${this.$t('FooterLinks.Woman.FaqReturns')}` : `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqReturns')}`,
            text: this.$t('Footer.Returns'),
            showArrow: true
          },
          {
            display: false,
            classes: '',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqExtraMembership')}`,
            text: this.$t('Footer.ExtraMembership'),
            showArrow: true
          },
          {
            display: this.country === CountryCodes.germany,
            classes: '',
            nuxtLink: 'cancel-membership',
            text: this.$t('MembershipStatusForm.Button.Quit'),
            showArrow: true
          },
          {
            display: true,
            classes: '',
            link: this.isWomenCategory ? `/${this.locale}-${this.country}${this.$t('FooterLinks.Woman.FaqSizeGuide')}` : `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqSizeGuide')}`,
            text: this.$t('Footer.SizeGuide'),
            showArrow: true
          }
        ],
        howDoesItWorkColumn: [
          {
            display: false,
            classes: 'hidden md:block ota-small mb-1',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqHowDoesItWork')}`,
            text: this.$t('Navigation.HowDoesItWork'),
            showArrow: false
          },
          {
            display: showLoyaltyProgram(this.country),
            classes: '',
            nuxtLink: 'loyalty',
            text: this.$t('Footer.Get10Euros'),
            showArrow: true
          },
          {
            display: true,
            classes: '',
            nuxtLink: 'webshop',
            text: this.$t('Loyalty.Webshop.Links.Webshop'),
            showArrow: true
          },
          {
            display: false,
            classes: 'hidden md:block',
            nuxtLink: 'signup',
            text: this.$t('HomePage.Signup'),
            showArrow: true,
            params: {}
          },
          {
            display: true,
            classes: this.locale === 'nl' ? '' : 'last-item',
            nuxtLink: this.isWomenCategory ? 'women-product' : 'lookbook-orientation',
            text: this.$t('Navigation.Lookbook'),
            showArrow: true,
            params: {
              orientation: Orientations.menoriginals
            }
          },
          {
            display: true,
            classes: 'hidden md:block',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.Sustainability')}`,
            text: this.$t('Footer.Sustainability'),
            showArrow: false
          },
          {
            display: false,
            classes: 'hidden md:block',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.FaqCollaborations')}`,
            text: this.$t('Footer.Influencers'),
            showArrow: false
          },
          {
            display: this.locale === 'nl',
            classes: 'last-item',
            link: this.$t('FooterLinks.VacanciesLink'),
            text: this.$t('Footer.Vacancies'),
            showArrow: true
          },
          {
            display: true,
            classes: 'last-item',
            nuxtLink: 'affiliate',
            text: this.$t('Footer.Affiliate'),
            showArrow: true
          }
        ],
        legalColumn: [
          {
            display: true,
            classes: '',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.TermsConditions')}`,
            text: this.$t('Footer.TermsConditions'),
            showArrow: false
          },
          {
            display: true,
            classes: '',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.TermsOfUse')}`,
            text: this.$t('Footer.TermsOfUse'),
            showArrow: false
          },
          {
            display: true,
            classes: '',
            link: `/${this.locale}-${this.country}${this.$t('FooterLinks.Privacy')}`,
            text: this.$t('Footer.Privacy'),
            showArrow: false
          },
          {
            display: this.country === CountryCodes.germany,
            classes: '',
            link: `/${this.locale}-${this.country}${'/right-of-withdrawal'}`,
            text: this.$t('Footer.RightOfWithdrawal'),
            showArrow: false
          },
          {
            display: [CountryCodes.germany, CountryCodes.austria, CountryCodes.switzerland, CountryCodes.france, CountryCodes.italy].includes(this.country),
            classes: '',
            link: `/${this.locale}-${this.country}${'/imprint'}`,
            text: this.$t('Footer.Imprint'),
            showArrow: false
          },
          {
            display: true,
            classes: '',
            link: `/${this.locale}-${this.country}${'/cookie-declaration'}`,
            text: this.$t('Footer.CookieDeclaration'),
            showArrow: false
          }
        ]
      }
    },
    currentCategory () {
      const withoutLangParam = this.$route.name?.replace('lang-', '')

      if ((withoutLangParam ?? '').startsWith(WebsiteCategories.women)) {
        return WebsiteCategories.women
      }

      return WebsiteCategories.men
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    isWomenCategory () {
      return this.currentCategory === WebsiteCategories.women
    }
  }
}
